<app-wait *ngIf="loading"></app-wait>
<ng-container *ngIf="!loading">
    <form [formGroup]="backupEmailForm" (ngSubmit)="submitEmail()">
        <app-message-box [content]="errors">
        </app-message-box>

        <ng-container *ngIf="workflow">
            <div class="suif-h3">Recovery Email</div>
            <div class="suif-body-copy">
                Please enter a second email address you can use to recover your account
                if you lose access to your account's primary email.
                If you do not have a second email now, you can add it later in your profile.
            </div>
        </ng-container>

        <ng-container *ngIf="!workflow">
            <div class="suif-body-copy">
                Once confirmed, this email can be used to recover your account
                if you lose access to your account's primary email.
            </div>
        </ng-container>
        <app-input label="Email"
                   formControlName="newEmail"
                   ngDefaultControl
                   fieldId="email-address"
                   inputmode="email"
                   type="email"
                   autoFocus></app-input>
        <app-input label="Confirm Email"
                   formControlName="confirmNewEmail"
                   ngDefaultControl
                   fieldId="confirm-email-address"
                   inputmode="email"
                   type="email"></app-input>

        <div class="button-row">
            <button
                    type="button"
                    class="btn btn-secondary"
                    (click)="cancel()"
                    (appOnEnter)="cancel()">
                {{workflow ? 'Back': 'Cancel'}}
            </button>
            <app-wait-button
                    buttonType="submit"
                    [cssClass]="submitButtonClass"
                    label="{{workflow ? 'Save & Continue' : 'Save'}}"
                    [waiting]="submitting"></app-wait-button>
        </div>
    </form>

    <div class="suif-body-copy" *ngIf="workflow">
        <hr/>
        <div class="more-options-text">
            <div class="suif-emphasis more-options-text-lead">not right now?</div>
            <span class="more-options-text-description">if you would prefer to set this option later, you can
                <button type="button" class="button-link skip-step-button" (click)="skip()">skip this step</button>
            </span>
        </div>
    </div>
</ng-container>
